import React, { useState, useEffect, useRef } from "react";
import { Route, Routes, Link, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./Dashboard";
import EmployeeDashboard from "../pages/EmployeeDashboard/EmployeeDashboard";
import TaxSlabListPage from "../pages/TaxSlab/TaxSlabList";
import PayrollListPage from "../pages/PayRolles/PayrollListPage";
import LeaveListPage from "../pages/Leaves/LeaveRequestListPage";
import LeaveBalanceApp from "../pages/Leave_Balance/LeaveBalanceApp";
import AttendanceApp from "../pages/Attendance/AttendanceApp";
import LeaveApprovalPage from "../pages/LeaveApprovalPage";
import LoginPage from "../pages/LoginPage";
import Designations from "../pages/Designation/DesignationList";
import Departments from "../pages/Department/DepartmentList";
import PayslipsPage from "../pages/PaySlips/PayslipsPage";
import HolidayPage from "../pages/Holiday/HolidayCalender";
import HolidayMasterPage from "../pages/Holiday/HolidayMasterList";
import ProjectList from "../pages/Project/ProjectList";
import TaskList from "../pages/Task/TaskList";
import ChallanMasterList from "../pages/Challans/ChallanList";
import { useDispatch, useSelector } from "react-redux";
import "../styles/layout.css";
import "../styles/styles.css";
import "../pages/Profile/Profile.css";
import { Logout } from "@mui/icons-material";
import {
  ArrowDropDown,
  ArrowDropUp,
  KeyboardArrowDown,
  KeyboardArrowUp
} from "@mui/icons-material";
import axios from "axios";
import AuthViewController from "../redux/actions/AuthViewController";
import { image_url } from "../redux/actions/AuthViewController";
import MasterViewController from "../redux/actions/masterApiActions";
import CompanyList from "../pages/Companies/CompanyList";
import EmployersList from "../pages/Employers/EmployersList";
import UserListPage from "../pages/Employees/UserListPage";
import RoleListPage from "../pages/Roles/RoleListPage";
import AnnouncementList from "../pages/Announcement/AnnouncementList";
import ActivationSuccessPage from "../pages/AccountActivationPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import EmployeeProfileVeiwController from "../redux/actions/EmployeeProfileApiAction";
import { hasPermission } from "../utils/permissionUtils";
import MainDashboard from "../pages/Dasboard/MainDashboard";
import AdminHolidayMasterList from "../pages/Holiday/AdminHolidayMasterList";
import EmployerHolidayMasterList from "../pages/Holiday/EmployerHolidayMasterList";
import EmployeeSelfOnboardingForm from "../pages/EmployeeOnboarding/EmployeeSelfOnboardingForm";
import ForgotPassword from "../pages/ForgotPassword/ForgotPasswordPage";
import OtpResetPassword from "../pages/ForgotPassword/OtpResetPassword";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { IconButton, Menu, MenuItem } from "@mui/material";
import DropDown from "../pages/Profile/ProfileDropDown";
import AccountSettings from "./AccountSettings";
import ReportListPage from "../pages/Reports/Reports";
import ScrollToTop from "./ScrollToTop";
import AppraisalCycleList from "../pages/Appraisal/AppraisalList";
import AppraisalReviewList from "../pages/AppraisalReview/AppraisalReviewList";
import { IMAGE_URL } from "../services/api";
import ProtectedImage from "./ProtectedImage";
import { getUserInfoFromToken } from "../utils/authUtils";
import TremsAndConditionPage from "../pages/Contract/ContractTermAndConditionList";
import ContractList from "../pages/Contract/ContractList";
import EmpTaxSlab from "../pages/EmployeeTaxSlab/AddEmployeeTaxSlab";
import EmpTaxSlabList from "../pages/EmployeeTaxSlab/EmployeeTaxSlabList";
import HomePage from "../pages/HomePage/HomePage";
import DocumentList from "../pages/Documents/DocumentList";

const routes = [
  {
    name: "Dashboard",
    path: "/",
    module: "dashboard"
  },
  {
    name: "Oragnizations",
    path: "/company",
    module: "oragnizations",
    children: [
      {
        name: "List",
        path: "/company",
        module: "company_list"
      },
      {
        name: "Employers",
        path: "/employer",
        module: "employer_management"
      }
    ]
  },
  {
    name: "Employees",
    path: "/users",
    module: "employee_management",
    children: [
      {
        name: "List",
        path: "/users",
        module: "employee_list"
      },
      {
        name: "Attendances",
        path: "/time-attendance",
        module: "attendance_management"
      }
    ]
  },
  {
    name: "Appraisals",
    path: "/appraisal",
    module: "appraisals",
    children: [
      {
        name: "Appraisal Cycle",
        path: "/appraisal",
        module: "appraisal_cycle"
      }
    ]
  },
  {
    name: "Review",
    path: "/review",
    module: "reviews",
    children: [
      {
        name: "Appraisal Review",
        path: "/review",
        module: "appraisal_reviews"
      }
    ]
  },
  {
    name: "Leave",
    path: "/leaves",
    module: "leave",
    children: [
      {
        name: "List",
        path: "/leaves",
        module: "leave_list"
      },
      {
        name: "Leave Balance",
        path: "/leave-balance",
        module: "leave_balance"
      },
      {
        name: "Holiday Calendar",
        path: "/holidays",
        module: "holidays"
      }
    ]
  },
  {
    name:"Documents",
    path:"/documents",
    module: "genrate_documents"
  },
  {
    name:"Tax Slab",
    path:"/employeet-tax-slab",
    module: "employee_tax_slab"
  },
  {
    name: "Salaries",
    path: "/payrolls",
    module: "salaries",
    children: [
      {
        name: "Payroll Management",
        path: "/payrolls",
        module: "payrolls"
      },
      {
        name: "Payslip Management",
        path: "/pay-slips",
        module: "pay_slips"
      },
      {
        name: "Report Management",
        path: "/reports",
        module: "report_management"
      }
    ]
  },
  {
    name: "Compliance",
    path: "/challan-master",
    module: "compliance",
    children: [
      {
        name: "Challan Master",
        path: "/challan-master",
        module: "challan_master"
      },

      {
        name: "Tax Slab Configuration",
        path: "/tax-slab",
        module: "tax_slab"
      }
    ]
  },
  {
    name: "Master Configuration",
    path: "/roles",
    module: "masters",
    children: [
      {
        name: "Role Management",
        path: "/roles",
        module: "roles"
      },
      {
        name: "Holiday Master",
        path: "/holiday-master",
        module: "holiday_master"
      }
    ]
  },
  {
    name: "Master Data",
    path: "/departments",
    module: "employer_master",
    children: [
      {
        name: "Department Management",
        path: "/departments",
        module: "departments"
      },
      {
        name: "Designation Management",
        path: "/designations",
        module: "designations"
      },
      {
    name: "Holiday Management",
    path: "/organization-holiday",
    module: "oragnization_holiday_management"
  },
    ]
  },
  {
    name: "Contracts",
    path: "/terms",
    module: "contract",
    children: [
      {
        name: "Terms And Conditions",
        path: "/terms",
        module: "contract_terms_conditions"
      },
      {
        name: "Contract Management",
        path: "/contract",
        module: "contract_managment"
      },
    ]
  },
  
  {
    name: "Projects",
    path: "/projects",
    module: "projects",
    children: [
      {
        name: "List",
        path: "/projects",
        module: "project_list"
      },
      {
        name: "Tasks & Issues",
        path: "/tasks",
        module: "task_issues_management"
      }
    ]
  },
  {
    name: "Announcements",
    path: "/announcement",
    module: "notifications"
  },
  {
    name: "Attendances",
    path: "/employee_attendance",
    module: "employee_attendance"
  },
  {
    name: "Payslips",
    path: "/employee_Payslips",
    module: "employee_payslips"
  },
  {
    name: "Task/Issue",
    path: "/employee_task_issue",
    module: "employee_task_issue"
  }
];
// {
//   name: "Company Management",
//   path: "/company",
//   module: "company_list"
// },
// {
//   name: "Employer Management",
//   path: "/employer",
//   module: "employer_management"
// },
// {
//   name: "Employee Management",
//   path: "/users",
//   module: "employee_management"
// },

// {
//   name: "Challan Master",
//   path: "/challan-master",
//   module: "challan_master"
// },
// {
//   name: "Holiday Management",
//   path: "/employer-holiday",
//   module: "holiday_management"
// },
// {
//   name: "Tax Slab Configuration",
//   path: "/tax-slab",
//   module: "tax_slab"
// },
// {
//   name: "Payroll Management",
//   path: "/payrolls",
//   module: "payrolls"
// },
// {
//   name: "Payslip Management",
//   path: "/pay-slips",
//   module: "pay_slips"
// },
// {
//   name: "Report Management",
//   path: "/reports",
//   module: "report_management"
// },
// {
//   name: "Leave Management",
//   path: "/leaves",
//   module: "leave_management",
//   children: [
//     {
//       name: "Apply Leave",
//       path: "/leaves",
//       module: "leave_apply"
//     },

//     {
//       name: "Leave Balance",
//       path: "/leave-balance",
//       module: "leave_balance"
//     },
//     {
//       name: "Holiday List",
//       path: "/holidays",
//       module: "holidays"
//     }
//   ]
// },
// {
//   name: "Attendance Management",
//   path: "/time-attendance",
//   module: "attendance_management"
// },
// {
//   name: "Leave Approvals",
//   path: "/leave-approval",
//   module: "leave_approval"
// },

// {
//   name: "Announcements",
//   path: "/announcement",
//   module: "notifications"
// }
// ];

function DefaultLayout() {
  const dispatch = useDispatch();
  const { logout, getUserDetails, getUserPermissions } = AuthViewController();
  const { userDetails, permissions, loading } = useSelector((state) => state.auth);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const token = localStorage.getItem('access_token');
  
  // const userType = localStorage.getItem("user_type");
  // const userId = localStorage.getItem("user_id");
  const companyName = userDetails?.company?.company_name || "Company";

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("access_token");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();

  const handleLogout = () => {
    setOpenSubMenu(null);
    setIsDrawerOpen(false);
    dispatch(logout());
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleSubMenuToggle = (index) => {
    setOpenSubMenu(openSubMenu === index ? null : index);
  };

  const formikRef = useRef();
          useEffect(() => {
          const { userType, userId } = getUserInfoFromToken();
          setUserType(userType);
          setUserId(userId);
        }, []);

  useEffect(() => {
    dispatch(getUserDetails());
    dispatch(getUserPermissions());
    const foundIndex = routes.findIndex(
      (route) =>
        route.children &&
        route.children.some((child) => location.pathname === child.path)
    );
    if (foundIndex !== -1) {
      setOpenSubMenu(foundIndex);
    }
    
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // useEffect(() => {
  //   setShowDropdown(false);
  // }, [userDetails]); // or [userDetails?.id]

  const getBreadcrumbs = () => {
    const path = location.pathname;
    const breadcrumbArray = [];

    const pushUnique = (item) => {
      if (!breadcrumbArray.some((b) => b.name === item.name)) {
        breadcrumbArray.push(item);
      }
    };

    routes.forEach((route) => {
      if (path.includes(route.path) && !route.children) {
        pushUnique(route);
      }
      if (route.children) {
        route.children.forEach((child) => {
          if (path.includes(child.path)) {
            pushUnique(route);
            pushUnique(child);
          }
        });
      }
    });

    return breadcrumbArray;
  };

  const breadcrumbs = getBreadcrumbs();
  const isLoginPage = location.pathname === "/login";
  const isActivationPage = location.pathname.startsWith("/activate/");
  const isResetPasswordPage = location.pathname.startsWith("/reset-password");

  if (!isAuthenticated) {
    return (
      <div
        className="app-container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Routes>
          <Route
            path="/onboarding-form/:uid/:token"
            element={<EmployeeSelfOnboardingForm />}
          />
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/otp-reset" element={<OtpResetPassword />} />
          <Route
            path="/activate/:uid/:token"
            element={<ActivationSuccessPage />}
          />
          <Route
            path="/reset-password/:uid/:token"
            element={<ResetPasswordPage />}
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="app-container">
      <header className="app-header">
        <button className="menu-button" onClick={toggleDrawer}>
          ☰
        </button>
        {userType === "Admin" ? (
          <h4 className="app-title">Admin Panel</h4>
        ) : (
          <ProtectedImage
            path={userDetails?.company?.company_logo}
            alt={`${companyName} Logo`}
            className="company-logo"
          />
        )}

        <div style={{ position: "relative" }}>
          <AccountSettings userDetails={userDetails} onLogout={handleLogout} />

          {/* {userDetails?.first_name && userDetails?.last_name && (
            <div
              className="user-initials-circle"
              title={`${userDetails.first_name} ${userDetails.last_name}`}
              onClick={(e) => {
                e.stopPropagation(); // Prevent bubbling issues
                setShowDropdown((prev) => !prev);
              }}
            >
              {`${userDetails.first_name[0]}${userDetails.last_name[0]}`.toUpperCase()}
            </div>
          )}

          {showDropdown && (
            <div ref={dropdownRef}>
              <DropDown userDetails={userDetails} onLogout={handleLogout} />
            </div>
          )} */}
        </div>
      </header>

      <nav className={`side-nav ${isDrawerOpen ? "open" : ""}`}>
        <ul>
          {routes.map((route, index) => {
            const showRoute =
              userType === "Admin" || hasPermission(permissions, route.module);

            if (!showRoute) return null;

            return (
              <li key={index}>
                {route.children ? (
                  <div>
                    <Link
                      to={route.path}
                      className={`side-nav-link ${
                        location.pathname === route.path ||
                        (route.children &&
                          route.children.some(
                            (child) => location.pathname === child.path
                          ))
                          ? "active"
                          : ""
                      }`}
                      onClick={() => handleSubMenuToggle(index)}
                    >
                      {route.name}
                      {openSubMenu === index ? (
                        <KeyboardArrowUp className="custom-icon" />
                      ) : (
                        <KeyboardArrowDown className="custom-icon" />
                      )}
                    </Link>
                    {openSubMenu === index && (
                      <ul className="sub-menu">
                        {route.children
                          .filter(
                            (child) =>
                              userType === "Admin" ||
                              hasPermission(permissions, child.module)
                          )
                          .map((child, childIndex) => (
                            <li key={childIndex}>
                              <Link
                                to={child.path}
                                className={`side-nav-link ${
                                  location.pathname === child.path
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  setOpenSubMenu(null);
                                  if (window.innerWidth < 768)
                                    setIsDrawerOpen(false);
                                }}
                              >
                                {child.name}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <Link
                    to={route.path}
                    className={`side-nav-link ${
                      location.pathname === route.path ? "active" : ""
                    }`}
                    onClick={() => {
                      setOpenSubMenu(null);
                      if (window.innerWidth < 768) setIsDrawerOpen(false);
                    }}
                  >
                    {route.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
      <ScrollToTop />
      <main className="app-main">
        <div className="breadcrumbs">
          <nav>
            <ol>
              {breadcrumbs.map((breadcrumb, index) => (
                <li key={index}>
                  <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
                </li>
              ))}
            </ol>
          </nav>
        </div>
        <div style={{ height: "calc(100vh - 64px)" }}>
          {" "}
          <Routes>
            <Route
              path="/"
              element={<MainDashboard />}
              // element={
              //   userType === "Employee" ? <EmployeeDashboard /> : <Dashboard />
              // }
            />
            <Route
              path="/login"
              element={<MainDashboard />}
              // element={
              //   userType === "Employee" ? <EmployeeDashboard /> : <Dashboard />
              // }
            />
            <Route path="/company" element={<CompanyList />} />
            <Route path="/employer" element={<EmployersList />} />
            <Route path="/users" element={<UserListPage />} />
            <Route path="/roles" element={<RoleListPage />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/designations" element={<Designations />} />
            <Route
              path="/holiday-master"
              element={<AdminHolidayMasterList />}
            />
            <Route
              path="/organization-holiday"
              element={<EmployerHolidayMasterList />}
            />
            <Route path="/challan-master" element={<ChallanMasterList />} />
            <Route path="/tax-slab" element={<TaxSlabListPage />} />
            <Route path="/payrolls" element={<PayrollListPage />} />
            <Route path="/pay-slips" element={<PayslipsPage />} />
            <Route path="/employee_Payslips" element={<PayslipsPage />} />
            <Route path="/reports" element={<ReportListPage />} />
            <Route path="/appraisal" element={<AppraisalCycleList />} />
            <Route path="/review" element={<AppraisalReviewList />} />
            <Route path="/leaves" element={<LeaveListPage />} />
            <Route path="/leave-balance" element={<LeaveBalanceApp />} />
            <Route path="/employeet-tax-slab" element={<EmpTaxSlabList />} />
            <Route path="/holidays" element={<HolidayPage />} />
            <Route path="/documents" element={<DocumentList />} />
            <Route path="/terms" element={<TremsAndConditionPage />} />
            <Route path="/contract" element={<ContractList />} />
            <Route path="/time-attendance" element={<AttendanceApp />} />
            <Route path="/employee_attendance" element={<AttendanceApp />} />
            <Route path="/leave-approval" element={<LeaveApprovalPage />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/tasks" element={<TaskList />} />
            <Route path="/employee_task_issue" element={<TaskList />} />
            <Route path="/announcement" element={<AnnouncementList />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default DefaultLayout;
